import i18n from 'shared/lib/i18n';

import { toSentenceCase } from '../../utils';
import { getFullName, getRoleName } from '../Person/utils';

export const getRoleNames = (roles) =>
  roles?.length
    ? [
        ...new Set(roles?.map(({ role }) => toSentenceCase(getRoleName(role)))),
      ].join(', ')
    : '';

export const formatResidents = (residents) => {
  if (!residents) return [];
  return residents.map((resident) => {
    const { residentRoles, id } = resident;
    const residentName = getFullName(resident);
    const residentUnits = residentRoles
      ?.map(({ propertyName }) => propertyName)
      .join(', ');

    if (!residentUnits) {
      return {
        label: residentName,
        value: id,
      };
    }

    return {
      label: `${residentName} | ${residentUnits}`,
      value: id,
    };
  });
};

export const getActionNames = () => ({
  deliveries: i18n.t('delivery.signOutPending'),
  sr: i18n.t('serviceRequest.active'),
  reservations: i18n.t('title.reservations'),
  visitors: i18n.t('title.activeVisitors'),
  createSr: i18n.t('serviceRequest.create'),
});
